import { render } from "./userDetail.vue?vue&type=template&id=31b060c2&scoped=true"
import script from "./userDetail.vue?vue&type=script&lang=js"
export * from "./userDetail.vue?vue&type=script&lang=js"

import "./userDetail.vue?vue&type=style&index=0&id=31b060c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b060c2"]])

export default __exports__